module.exports = __webpack_public_path__ + "img/cz.0cee70c2.png";